import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './vuex'
import axios from './axios'
import VideoPlayer from 'vue-video-player'
import './utils/rem.js'

Vue.use(VideoPlayer)
require('vue-video-player/src/custom-theme.css')
Vue.use(ElementUI)

 let head = document.getElementsByTagName('head');        // 创建head标签
  let meta1 = document.createElement('meta');           // 创建meta标签
  let meta2 = document.createElement('meta');
  
  meta1.name = "keywords";                         // 设置name
  meta2.name = "description";

router.beforeEach((to,from,next) => {
	console.log(to,from)
		next()
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js